<template>
    <div class="page page--message layout">
        <div class="layout__header layout__header--msg">
            <h2>消息箱</h2>
        </div>
        <div class="layout__body">
			<div class="message__list">
                <a class="message__item" v-for="message in messageList" :key="message.id" @click="goArtical(message)">
                    <div v-if="message.read === 0" class="message__status">未读消息</div>
                    <div class="message__content">
                        <div class="message__top">
                            <div class="message__img">
                                <img :src="message.cover" alt="">
                            </div>
                            <div class="message__title">{{message.title}}</div>
                        </div>
                        <div class="message__summary">{{message.summary}}</div>
                    </div>
                    <div class="message__time">{{message.created_at}}</div>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
// @ is an alias to /src
import API from '@/api.js';
// var $win = $(window);
// var $doc = $(document);
// var loadding = false;
export default {
	name: 'home',
	data () {
		return {
			hasMsg: 0, // 是否存在未读消息
			messageList: [], // 消息箱列表
			lodding: false,
			pageBean: {
				page: 1,
				page_size: 10
			}
		};
	},
	methods: {
		getMessage () {
			API.getInfoList(this.pageBean).then((res) => {
				if (res.data.code === 200) {
					if (!res.data.data.list.length) {
					} else {
						this.messageList = this.messageList.concat(res.data.data.list);
						this.pageBean.page++;
					}
					this.lodding = false;
				}
			});
		},
		goArtical (data) {
			if (data.type === 2) {
				// 若图文是外链，且未被删除则直接跳转外链
				// 调用图文详情接口，后端判断该消息已读
				API.getInfoBox(data.id).then((res) => {
					window.location.href = data.content;
				});
			} else {
				this.$router.push(`/artical/box/${data.id}`);
			}
		},
		getScrollTop () {
			let scrollTop = 0;
			let bodyScrollTop = 0;
			let documentScrollTop = 0;
			if (document.body) {
				bodyScrollTop = document.body.scrollTop;
			}
			if (document.documentElement) {
				documentScrollTop = document.documentElement.scrollTop;
			}
			scrollTop = (bodyScrollTop - documentScrollTop > 0) ? bodyScrollTop : documentScrollTop;
			return scrollTop;
		},
		getScrollHeight () {
			let scrollHeight = 0;
			let bSH;
			let dSH;
			if (document.body) {
				bSH = document.body.scrollHeight;
			}
			if (document.documentElement) {
				dSH = document.documentElement.scrollHeight;
			}
			scrollHeight = (bSH - dSH > 0) ? bSH : dSH;
			return scrollHeight;
		},
		getWindowHeight () {
			let windowHeight = 0;
			if (document.compatMode === 'CSS1Compat') {
				windowHeight = document.documentElement.clientHeight;
			} else {
				windowHeight = document.body.clientHeight;
			}
			return windowHeight;
		},
		setWechat () {
			let self = this;
			API.getWechatAssign().then((res) => {
				let data = res.data.data;
				self.$wx.config({
					debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
					appId: data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
					timestamp: data.timestamp, // 必填，生成签名的时间戳
					nonceStr: data.nonceStr, // 必填，生成签名的随机串
					signature: data.signature, // 必填，签名，见附录1
					jsApiList: ['hideOptionMenu', 'showOptionMenu']
				});
				self.$wx.ready(function () {
					self.$wx.showOptionMenu();
				});
				self.$wx.showOptionMenu();
			});
		}
	},
	created () {
	},
	mounted () {
		let _self = this;
		_self.getMessage();
		window.onscroll = function () {
			if (!document.querySelector('.page--message')) {
				return;
			}
			if (_self.getScrollTop() + _self.getWindowHeight() === _self.getScrollHeight() && !this.lodding) {
				_self.lodding = true;
				_self.getMessage();
			}
		};
		_self.setWechat();
		_self.$wx.showOptionMenu();
	}
};
</script>
